import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  readerHeaderContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: '99px',
    zIndex: 999,
    backgroundColor: ({ activeTheme }) => `${theme.reader.colors[activeTheme]?.barColor} !important`,
    borderBottom: ({ activeTheme }) => `0.5px solid ${theme.reader.colors[activeTheme]?.backdropOnColor} !important`,
  },
  readerViewContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'relative',
    height: '100%',
    width: 'calc(100% - 120px)',
    margin: '99px auto',
    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      width: 'calc(100% - 40px)',
    },
  },
  readerContainer: {
  },
  printHidden: {
    '@media print': {
      display: 'none',
    },
  },
  copyDisabled: {
    // svg render mode draws selectable <text> as well as the text layer
    '&, & *': {
      userSelect: 'none !important',
    },
  },
  emptySelection: {
    opacity: 0,
  },
  readerView: {
    overflow: 'hidden',
    boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 20px',
    lineHeight: 'initial',
    '& .react-pdf': {
      '&__Page__textContent': {
        width: 'calc(100% - 2px) !important',
        height: 'calc(100% - 2px) !important',
        '& span': {
          display: 'inline-block',
        },
        '& span > span': {
          opacity: 0.8,
        },
      },
    },
  },
  transformComponent: {
    userSelect: 'unset',
  },
  arrowBg: {
    width: 48,
    height: 290,
    opacity: 0.5,
    display: 'flex',
    borderRadius: 6,
    top: 'calc(50% - 145px)',
    position: 'absolute',
    transition: 'opacity 0.3s',
    backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropColor,
  },
  arrowIconBtn: {
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
  leftArrow: {
    left: '-54px',
  },
  rightArrow: {
    right: '-54px',
  },
  icon: {
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
  textThemeColor: {
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
  highlight: {
    backgroundColor: theme.palette.colors.readerPrimaryColor,
    color: 'unset',
  },
  timelineContainerPDF: {
    backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.barColor,
    borderTop: ({ activeTheme }) => `0.5px solid ${theme.reader.colors[activeTheme]?.backdropOnColor}`,
  },
}));

export default useStyles;
